     import {
  Smartphone,
  PhoneCall,
  CreditCard,
  Luggage,
  Car,
  Wifi,
  UserCheck,
  Award,
} from 'lucide-react'
 
// Custom image path can be added to `imageSrc` for any card if desired.
const tips = [
  {
    number: 1,
    imageSrc: '/img/safety-tips/Sharelive.svg',
    icon: Smartphone,
    title: 'Share live location with someone you trust',
    description:
      'Let a friend or family member know your travel plans and share your live location during your journey.',
  },
  {
    number: 2,
    imageSrc: '/img/safety-tips/Emergencycontacts.svg',
    icon: PhoneCall,
    title: 'Keep emergency contacts ready',
    description:
      'Save local emergency numbers and keep your phone charged while traveling.',
  },
  {
    number: 3,
    imageSrc: '/img/safety-tips/Bookingspayments.svg',
    icon: CreditCard,
    title: 'Stay alert during bookings & payments',
    description:
      'Book hotels, transportation, and activities only through trusted platforms. Avoid sharing OTPs or payment details with strangers.',
  },
  {
    number: 4,
    imageSrc: '/img/safety-tips/Keepvaluablessecure.svg',
    icon: Luggage,
    title: 'Keep valuables secure',
    description:
      'Carry only essential cash and keep your passport, wallet, and personal belongings in secure places.',
  },
  {
    number: 5,
    imageSrc: '/img/safety-tips/Plantransport.svg',
    icon: Car,
    title: 'Plan your transport in advance',
    description:
      'Choose verified taxis or trusted ride-sharing services, especially when traveling at night.',
  },
  {
    number: 6,
    imageSrc: '/img/safety-tips/Stayconnected.svg',
    icon: Wifi,
    title: 'Stay connected during solo moments',
    description:
      'Avoid staying offline for long periods in unfamiliar locations. Keep your family or friends updated regularly.',
  },
  {
    number: 7,
    imageSrc: '/img/safety-tips/Travelatyourowncomfortlevel.svg',
    icon: UserCheck,
    title: 'Travel at your own comfort level',
    description:
      'Never feel pressured into changing your travel plans or doing anything that makes you uncomfortable.',
  },
  {
    number: 8,
    imageSrc: '/img/safety-tips/YourSafetycomesFirst.svg',
    icon: Award,
    title: 'Your safety comes first',
    description:
      'A safe and comfortable journey is always more important than completing an itinerary.',
  },
]
 
export default function SafetyTips() {
  return (
    <section id="tips" className="bg-white py-12 lg:py-16">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {tips.map((tip) => (
            <TipCard key={tip.number} {...tip} />
          ))}
        </div>
      </div>
    </section>
  )
}
 
function TipCard({ number, icon: Icon, imageSrc, title, description }) {
  return (
    <div className="group rounded-2xl border border-[#F7F3FC] bg-white p-4 sm:p-5 transition-all duration-200 hover:border-[#D8CEF6] hover:shadow-sm">
      <div className="flex items-start gap-3.5">
        {/* Icon or Image Container */}
        <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl  overflow-hidden">
          {imageSrc ? (
            <img
              src={imageSrc}
              alt={title}
              className="h-12 w-12 object-contain"
            />
          ) : (
            <Icon className="h-5.5 w-5.5 stroke-[1.8]" />
          )}
        </div>
 
        {/* Text Content */}
        <div className="flex-1 min-w-0">
          <h3 className="text-xs sm:text-[12px] font-bold leading-snug text-[#0F172A]">
            {number}. {title}
          </h3>
          <p className="mt-1 text-[11px] sm:text-[11px] leading-relaxed text-[#64748B]">
            {description}
          </p>
        </div>
      </div>
    </div>
  )
}
 
 
 